import { Component, ViewChild, ViewContainerRef, OnInit, ElementRef, AfterViewInit, ChangeDetectorRef, HostListener, Renderer2 } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { ADN_PLUS } from '../../models';
import { RadioColorEnum } from '../../enums/radio.enum';
import { CtButtonComponent } from '../ct-button/ct-button.component';
import { breakpoints } from '../../environments/environment.breakpoints';import { CtInputTextComponent } from '../ct-input-text/ct-input-text.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'ct-radio',
  templateUrl: './ct-radio.component.html',
  styleUrls: ['./ct-radio.component.css'],
  host: {
    '[id]': 'getId()',
  }
})
export class CtRadioComponent extends InputBaseComponent implements OnInit, AfterViewInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('amountInputRadioReceipt', { read: ViewContainerRef }) inputRadioReceiptContainer : ViewContainerRef;
  @ViewChild('buttonRadioReceipt', { read: ViewContainerRef }) buttonRadioReceiptContainer : ViewContainerRef;
  @ViewChild('inputCheckbox', { static: false }) checkboxInput: ElementRef<HTMLInputElement>;

  //components
  public radioReceiptInputComponent : CtInputTextComponent;
  public radioReceiptButtonComponent : CtButtonComponent;

  //properties
  private descriptionValue: string;
  public isChecked: boolean;
  private familyValue: any;
  private border: boolean;
  private value: any;
  private color : RadioColorEnum = RadioColorEnum.Default;
  public labelStyles: any = {};
  private isRadioReceipt : boolean = false;

  //util
  public isMedium: boolean = false;
  public isSmall: boolean = false;
  public isExtraSmall: boolean = false;
  public isContentVisible: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize(): void {
    const screenWidth = window.innerWidth;
    this.isMedium = screenWidth >= breakpoints.L;
    this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
    this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
  }

  constructor(private renderer : Renderer2) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.checkScreenSize();
  }

  ngAfterViewInit(): void {
    this.setProperties(this);
    this.containFamily();
    this.setCheckboxStatus(this.getMetaData().controlProperties.isChecked);
    this.paintRadioReceiptContent();
  }

  private paintRadioReceiptContent(): void {
    if(!this.isRadioReceipt) return;
    const inputMetadata = this.getInputComponentMetadata();
    const buttonMetadata = this.getButtonComponentMetadata();
    const radioReceiptInputComponent = this.paintChildren({models : [inputMetadata]}, this.inputRadioReceiptContainer)[0] as InputBaseComponent;
    this.radioReceiptButtonComponent = this.paintChildren({models : [buttonMetadata]}, this.buttonRadioReceiptContainer)[0] as CtButtonComponent;
    if (radioReceiptInputComponent instanceof CtInputTextComponent) {
      this.radioReceiptInputComponent = radioReceiptInputComponent as CtInputTextComponent;
    }
    this.setClassesToInputRadioReceipt();
  }

  private setClassesToInputRadioReceipt(): void {
    if(!this.radioReceiptInputComponent) return;
    this.renderer.setStyle(this.radioReceiptInputComponent.formControl.nativeElement, 'font-size', '15px');
    this.renderer.setStyle(this.radioReceiptInputComponent.formControl.nativeElement, 'font-weight', '700');
    this.renderer.setProperty(this.radioReceiptInputComponent.formControl.nativeElement.style, 'cssText', 
      `${this.radioReceiptInputComponent.formControl.nativeElement.style.cssText}; color: rgb(0, 46, 91) !important;`);
  }

  public onCheckboxChange(): void {
    if(!this.containFamily()) return;
    this.paintChildren(this.getMetaData(), this.target);
    this.isContentVisible = !this.isContentVisible;
  }

  public clearSelectionVisual(): void {
    this.renderer.setProperty(this.checkboxInput.nativeElement, 'checked', false);     // Deselect the radio button
    this.isContentVisible = false;      // Hide any extended content triggered by the selection
  }

  private setCheckboxStatus(status: boolean): void {
    this.checkboxInput.nativeElement.checked = status;
    this.setIsChecked(status);
  }

  containFamily(component: any = this.getMetaData()): boolean {
    const size: number = component.models.length;
    if (size > 0) {
      return true;
    }
    return false;
  }

  public executeEvent(): void {
    let action = this.getEvent('onSelect');
    if (action) {
      this.executeAction2(action);
    }
  }

  private getButtonComponentMetadata() {
    return {
      ctType: 'CtButton',
      controlProperties: {  
        hidden : false,
        listenedComponentId: "",
        listenedProperty: "",
        disabled: false,
        modelId: "",
        btnBlock: false,
        type : "Icon",
        buttonText: 'hola',
        buttonColor: 'Primary',
        icon: "fa fa-refresh",
        id: `RADIO_RECEIPT_BUTTON_COMPONNET_${0}`,
      },
      controlActions: [
        this.getEvent('onClick')
      ],
      models: []
    };
  }
  
  private getInputComponentMetadata() {
    return {
      ctType: "CtInputText",
      controlProperties: {
        hidden: false,
        oneLineControl: true,
        listenedComponentId: "",
        listenedProperty: "",
        pickId: "",
        readOnly: true,
        required: false,
        requiredMessage: "",
        isFilterInput: false,
        tooltipPosition: "left",
        labelPosition: "left",
        inputIcon: "",
        id: "RADIO_RECEIPT_INPUT_COMPONNET_0",
        modelId: "",
        value: "",
        isPassword: false,
        length: 250.0,
        labelValue: "",
        pattern: "",
        patternMessage: "",
        placeHolder: "",
        tooltipMessage: "Monto que ha transferido a la cuenta oficial de la Sociedad de Seguros de vida, el cual tiene disponible para procesar el pago de la planilla"
      },
      controlActions: [],
      models: []
    }
  }


  public getRadioBackgroundColor(): string {
    switch(this.color) {
      case RadioColorEnum.White:
        return 'white';
      default:
        return '';
    }
  }

  public getIsChecked(): boolean { 
    return this.checkboxInput.nativeElement.checked;
  }

  public getFamilyValue(): any { return this.familyValue; }
  public getBorder(): boolean { return this.border; }
  public getValue(): any { return this.value; }
  public getDescriptionValue(): string { return this.descriptionValue;}
  public getColor(): RadioColorEnum { return this.color; }
  public getIsRadioReceipt(): boolean { return this.isRadioReceipt; }

  public setIsChecked(value: boolean): void { this.isChecked = value; }
  public setFamilyValue(value: any): void { this.familyValue = value; }
  public setBorder(value: boolean): void {  this.border = value; }
  public setValue(value: any): void { this.value = value; }
  public setDescriptionValue(value: string): void { this.descriptionValue = value; }
  public setColor(value: RadioColorEnum): void { this.color = value; }
  public setIsRadioReceipt(value: boolean): void { this.isRadioReceipt = value; }
}